import { getAuth } from "firebase/auth";

// initial state
const state = {
  user: null,
  isAuthReady: false,
};

// getters
const getters = {
  isAuthenticated: (state) => !!state.user,
  currentUser: (state) => state.user,
  isAuthReady: (state) => state.isAuthReady,
};

// actions
const actions = {
  fetchUser({ commit }, user) {
    commit('setAuthReady', true);
    commit('setUser', user ? {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
    } : null);
  },
  async logout({ commit }) {
    await getAuth().signOut();
    commit('setUser', null);
  },
};

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setAuthReady(state, isReady) {
    state.isAuthReady = isReady;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};